import React, { useEffect, useState } from 'react'
import { Container, Title, Balance, Menu } from './HeaderStyled'
import { ReactComponent as MenuSVG } from '../../../assets/svg/menu-icon.svg'
import { HEADER_PROPS } from './interfaces'
import { aboveTypes } from 'pages/types'
import floorFigure from './helpers/floorFigure'
import helperClickHandler from './helpers/clickHandler'
import updateBalance from './helpers/updateBalance'
import Currencies from 'functions/currency/getCurrencySymbol'

export default function Header({
  gameInfo,
  title,
  betInfoBalance,
  handleAbove,
  colors,
  sfx,
  fontSize,
  letterSpace,
  balanceUpdateOn,
  updateNow,
}: HEADER_PROPS) {
  const { currency, balance, precision } = gameInfo
  const [localBalance, setlocalBalance] = useState<string>(balance)

  useEffect(() => setlocalBalance(floorFigure(balance, precision)), [
    balance,
    precision,
  ])

  useEffect(() => {
    updateBalance(
      balanceUpdateOn,
      setlocalBalance,
      betInfoBalance,
      precision,
      updateNow,
    )
  }, [betInfoBalance, updateNow])

  const [btnClick, setBtnClick] = useState<boolean>(false)

  const clickHandler = (p: aboveTypes) =>
    helperClickHandler(p, setBtnClick, handleAbove)

  return (
    <Container data-testid='header'>
      <Title
        textColor={colors.secondary}
        fontSize={fontSize}
        letterSpace={letterSpace}
      >
        {title}
      </Title>
      <Balance textColor={colors.quaternary}>
        <span>{Currencies[currency]}</span>
        <p>{localBalance && localBalance}</p>
      </Balance>
      <Menu
        btnClick={btnClick}
        background={colors.secondary}
        textColor={colors.tertiary}
        onClick={() => {
          sfx.play()
          clickHandler('settings')
        }}
      >
        <MenuSVG />
      </Menu>
    </Container>
  )
}
